<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Training Evaluations"></a-page-header>

        <a-card type="inner" size="small" >
            <a-form-model :form="form" :model="formData" labelAlign="left">
                <a-table
                    class="pcp-table"
                    :columns="EvaluationColumns"
                    :dataSource="tableData"
                    :loading="loading"
                    rowKey="id"
                    :pagination="false"
                    childrenColumnName=""
                    :rowClassName="(r) => r.is_heading ? 'row-heading' : '' "
                    bordered
                >

                    <div slot="no" slot-scope="record" class="text-small text-center" v-show="! record.is_heading">
                        {{ record.idx }}
                    </div>

                    <div slot="name" slot-scope="record" class="text-small text-left">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </div>

                    <div slot="action" slot-scope="record" style="text-align: center">
                        <template v-if="record.is_heading">
                            <a-space>
                                <a-tooltip title="Tambah Evaluasi">
                                    <a-button size="small" type="primary" icon="plus" @click="showModal('', record.id)" />
                                </a-tooltip>
                            </a-space>
                        </template>
                        <template v-else>
                            <a-space>
                                <a-tooltip title="Edit">
                                    <a-button size="small" type="primary" icon="edit" @click="showModal(record.id, 0)" />
                                </a-tooltip>
                                <a-tooltip title="Delete">
                                    <a-popconfirm title="Are you sure you want to delete this record" @confirm="deleteItem(record.id)">
                                        <a-button size="small" icon="delete" type="danger" :loading="processing.includes(record.id)"></a-button>
                                    </a-popconfirm>
                                </a-tooltip>
                            </a-space>
                        </template>
                    </div>

                </a-table>
            </a-form-model>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleModal"
            :closable="false"
            width="50%"
        >
            <classical-admin-training-evaluation-form :trainingEvalId="id" :parentId="parentId" @handleClose="closeModal"/>
        </a-modal>
    </div>
</template>

<script>
const EvaluationColumns = [
    {
		key: 'no',
		title: 'No',
        align: 'center',
		scopedSlots: {customRender: 'no'},
	},
    {
		key: 'name',
		title: 'Nama',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    data() {
        return {
            EvaluationColumns,
            form: this.$form.createForm(this),
            formData: {},
            loading: false,
            items: [],
            processing: [],
            visibleModal: false,
            id: 0,
            parentId: 0
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        tableData() {
            let collection = []

            this.items.forEach(function (item, index) {
                collection.push({
                    idx: 0,
                    id: item.id,
                    name: item.name,
                    is_heading: true,
                    parent_id: null
                })

                let idx = 0

                item.children.forEach(function (itemChild, index) {
                    idx++
                    collection.push({
                        idx: idx,
                        id: itemChild.id,
                        name: itemChild.name,
                        is_heading: false,
                        parent_id: item.id
                    })
                })
            })

            return collection
        }
    },
    methods: {
        getItems(){
            this.loading = true

            this.$http
                .get(this.routeUri('api.admin.training.evaluation'))
                .then(response => this.items = response.data.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        showModal(id, parentId) {
            this.id = id.toString()
            this.parentId = parentId
            this.visibleModal = true
        },
        closeModal(isRefresh) {
            this.visibleModal = false

            if (isRefresh == true) {
                this.getItems()
            }
        },
        deleteItem(id) {
            this.processing.push(id)

            this.$http.delete(this.routeUri('api.admin.training.evaluation.destroy', { training_evaluation: id }))
                .then((response) => this.handleActionSuccess())
                .catch((error) => this.handleXhrError(error))
                .finally(() => _.pull(this.processing, id))
        },
        handleActionSuccess() {
            this.$message.success("Record has been deleted")
            this.getItems()
        },
    },
}
</script>
